/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { getBaseQueryKey } from "../utils/queryKeyHelpers";

// The profiles list is the only cache a profile write invalidates. Editing a profile is
// deliberately a template-only change (locked decision #2), so no assigned user's access moves
// and nothing that reads user access needs refreshing.
const basePermissionProfileKeys = [getBaseQueryKey(Query_Keys.permission_profiles)];

export const permissionProfileMutationKeyGroups = {
  create: basePermissionProfileKeys,
  update: basePermissionProfileKeys,
  delete: basePermissionProfileKeys,
};
